import { useAuthStore } from '@/store/authStore'

type Handler = (payload: any) => void

const handlers: Record<string, Handler[]> = {}
let es: EventSource | null = null
let retryDelay = 2000
let connected = false

export function on(type: string, handler: Handler) {
  handlers[type] = handlers[type] || []
  handlers[type].push(handler)
}

export function off(type: string, handler: Handler) {
  if (handlers[type]) {
    const index = handlers[type].indexOf(handler)
    if (index > -1) {
      handlers[type].splice(index, 1)
    }
  }
}

export function startEvents() {
  if (es) return
  const base = (import.meta.env.DEV ? '' : (import.meta.env.VITE_API_URL?.replace(/\/api$/, '') || ''))
  
  // 🔥 EventSource 不支持自定义 header，需要通过 URL 参数传递 token
  const { token } = useAuthStore.getState()
  const url = token 
    ? `${base}/api/events/stream?token=${encodeURIComponent(token)}`
    : `${base}/api/events/stream`
  
  console.log(`🔌 [SSE] 连接 SSE 流: ${url.substring(0, 50)}...`)
  es = new EventSource(url)
  es.onopen = () => {
    connected = true
    retryDelay = 2000
    const list = handlers['sse_status'] || []
    list.forEach(h => h({ connected: true }))
    if (import.meta.env.DEV) console.debug('[SSE] connected')
  }
  es.addEventListener('message', (e) => {
    try {
      const data = JSON.parse((e as MessageEvent).data)
      const list = handlers[data.type] || []
      list.forEach(h => h(data.payload))
    } catch {}
  })
  es.onerror = () => {
    try { es && es.close() } catch {}
    es = null
    if (connected) {
      connected = false
      const list = handlers['sse_status'] || []
      list.forEach(h => h({ connected: false }))
      if (import.meta.env.DEV) console.warn('[SSE] disconnected, will retry...')
    }
    // 退避重连
    setTimeout(() => {
      retryDelay = Math.min(retryDelay * 2, 30000)
      startEvents()
    }, retryDelay)
  }
}

export function isSseConnected() { return connected }


